// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/frost-and-ice-formation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/frost-and-ice-formation/frost-and-ice-formation.js';

mount([g0]);
